import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Endpoints } from "../../Global/Endpoints";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";

const LoadPdf = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const { document } = location.state || {}; // Get the document data from state
    const [pdfDocuments, setPdfDocuments] = useState([]);
    const [loading, setLoading] = useState(true);
    const token = localStorage.getItem("AccessToken") || "YOUR_ACCESS_TOKEN_HERE";
    const contract = useSelector((state) => state.userData);

    const ssoData = useSelector((state) => state.sso.ssoUserData);
    const isHighmarkPortal = ssoData?.Portal === "Highmark";

    useEffect(() => {
        const fetchPdfDocuments = async () => {
            if (!document) {
                setLoading(false);
                return;
            }

            try {
                const payload = {
                    _Params: JSON.stringify({
                        AuthNo: document.AuthNo,
                        CPTDesc: document.CPTDesc,
                        Contract: document.Contract,
                        MemberID: document.MemberID,
                        DeviceType:"PatientPortal",
                        EmailID:contract.userData.EmailID
                    }),
                };

                const response = await axios.post(
                    Endpoints.LoadLetter,
                    payload,
                    {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (response.data && response.data.length > 0) {
                    setPdfDocuments(response.data);
                } else {
                    toast.error(t('nopdfdocuments'));
                }
            } catch (error) {
                toast.error(t('failedtoloadpdf'));
            } finally {
                setLoading(false);
            }
        };

        fetchPdfDocuments();
    }, [document, token]);

    const handlePdfClick = (pdfDocument) => {
        navigate("/pdf-viewer", {
            state: {
                pdfUrl: pdfDocument.PDF_Document, // Ensure the PDF URL is correct
                docType: pdfDocument.DocType,
                date: pdfDocument.Date,
                MemberID: pdfDocument.MemberID,
            },
        });
    };

    return (
        <>
            <ToastContainer />

            {isHighmarkPortal ? 
                <div className="col-md-6 mt-4 d-flex inner-page-heading-wrapper">
                <button className="win-back-btn" onClick={() => navigate(-1)}>
                    <span>
                    <i className="bi bi-chevron-left"></i>
                    </span>
                </button>       
                <h2 className="page-heading">
                {document?.CPTDesc === "View All Documents" 
                    ? `${document.AuthNo || "N/A"}`
                    : document?.CPTDesc}
                </h2>
                </div>:
                <div className="col-md-6 mt-4 d-flex inner-page-heading-wrapper">
                <button className="win-back-btn" onClick={() => navigate(-1)}>
                    <span>
                    <i className="bi bi-chevron-left"></i>    
                    {t('Back')}        
                    </span>
                </button>       
                <h2 className="page-heading">
                {document?.CPTDesc === "View All Documents" 
                    ? `${document.AuthNo || "N/A"}`
                    : document?.CPTDesc}
                </h2>
                </div>
            }

            {/* <div className="col-md-12 col-lg-12 mt-4 inner-page-heading-wrapper">
                <button
                    className="win-back-btn"
                    onClick={() => navigate(-1)}
                >
                    <span>
                        <i className="bi bi-chevron-left"></i> {t('back')}
                    </span>
                </button>
                <h2 className="page-heading">
                {document?.CPTDesc === "View All Documents" 
                    ? `${document.AuthNo || "N/A"}`
                    : document?.CPTDesc}
                </h2>
                </div> */}

            <div className="col-md-12 col-lg-12 mt-0">
                {loading ? (
                    <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
                ) : pdfDocuments.length > 0 ? (
                    <div className="documents-list">
                        {pdfDocuments.map((pdf, index) => (
                            <div
                                key={index}
                                className="document-item"
                                onClick={() => handlePdfClick(pdf)}>
                                <div>
                                    <strong>{pdf.DocType || "Unknown Document"}</strong>
                                    <p style={{ margin: 0, color: "gray", fontSize: "12px" }}>
                                        {pdf.Date }
                                    </p>
                                </div>
                                <div className="document-type-icon-wrapper document-type-pdf"></div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p style={{ textAlign: "center", color: "gray" }}>{t('nopdfdocumentsavailable')}</p>
                )}
            </div>
        </>
    );
};

export default LoadPdf;
